export enum ReportSortOption {
  sortCropFieldName = 'sortCropFieldName',
  sortCropName = 'sortCropName',
}

export enum ReportManureSubstancesView {
  manureDetails = 'manureDetails',
  manureType = 'manureType',
  period = 'period',
}

export interface ReportSort {
  option: ReportSortOption;
  descending: boolean;
}

export enum ReportSortButtonAction {
  sortOptions = 'sortOptions',
  sortDirection = 'sortDirection',
}

export enum ReportSelectAction {
  manureSubstancesView = 'manureSubstancesView',
}

export interface ReportSorterRequest<T> {
  elements: T[];
  option: ReportSortOption;
  descending: boolean;
  cropFieldNameFunc: (x: T) => string;
  cropNameFunc: (x: T) => string;
}
